var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGeneralInformationDoctor = function SvgGeneralInformationDoctor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#999",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.253 16.704h-1.875v-1.89h-.75v1.89H9.753v.75h1.875v1.86h.75v-1.86h1.875zM12.003 2.25A3.754 3.754 0 0 0 8.253 6a3.754 3.754 0 0 0 3.75 3.75A3.754 3.754 0 0 0 15.753 6a3.754 3.754 0 0 0-3.75-3.75m0 8.25a4.505 4.505 0 0 1-4.5-4.5c0-2.482 2.019-4.5 4.5-4.5 2.482 0 4.5 2.018 4.5 4.5s-2.018 4.5-4.5 4.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.503 12.379v7.496c0 1.034.842 1.875 1.875 1.875h13.125v-9.371zM20.253 22.5H6.378a2.63 2.63 0 0 1-2.625-2.625v-8.246h16.5z"
  }))));
};
export default SvgGeneralInformationDoctor;